'use client'

import * as React from 'react'
import FastMarquee from 'react-fast-marquee'
import { cn } from '@/lib/utils'

export interface MarqueeProps {
  className?: string
  children: React.ReactNode
  speed?: number
  gap?: number
  reverse?: boolean
}

export function Marquee({
  className,
  children,
  speed = 50,
  gap = 16,
  reverse = false,
}: MarqueeProps) {
  return (
    <FastMarquee
      className={cn('w-full', className)}
      speed={speed}
      direction={reverse ? 'right' : 'left'}
      autoFill
    >
      <div className="flex items-center" style={{ gap: `${gap}px`, marginRight: `${gap}px` }}>
        {children}
      </div>
    </FastMarquee>
  )
}
